import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const twoYearsOldDrawing: BlogMetaData = {
  title: '2歳のお絵描き｜何を描く？道具の選び方・声かけ・困ったときの対処（モンテッソーリ流）',
  description:
    '2歳のお絵描きは何を描く？なぐり描きの意味、クレヨンなど道具の選び方と安全面、壁に描く・口に入れるなどの困りごとの対処、声かけ例までモンテッソーリの視点で解説します。',
  thumbnailUrl: '/img/blog-2-years-old-drawing.webp',
  filePath: buildBlogFilePath('2-years-old-drawing'),
  category: BLOG_CATEGORY.PLAY_TOOLS,
};
